<div class="not-found">
  <section class="not-found-content-wrapper">
    <img
      src="assets/images/broken_paper.svg"
      width="111"
      height="100"
      alt="broken paper"
      class="not-found__illustration"
    />
    <h1 class="not-found__title">Oups, cette page n'existe pas</h1>
    <!-- <p class="not-found__description">
      {{ '404.error.description' | transloco }}
    </p> -->
    <a routerLink="" button> Acceuil </a>
  </section>
</div>
